import './style/BackToHome.css'

export default function BackToHome() {
    return (
    <div className="back-to-home">
        <a href="/">Go back to home page</a>
    </div>
    );
}